import { URLUtils, WMPUtils } from '../../utils';
import { CAMPAIGNS } from '../../widgets/HotelManager/Campaigns';

export const CampaignParams = {
    compose() {
        if (!(CAMPAIGNS.includes(WMPUtils.getCampaignId()) && WMPUtils.isCampaignNotExpired())) {
            return '';
        }
        const campaignInfoParam = WMPUtils.isCampaignNotExpired()
            ? `;campaignInfo=${btoa(WMPUtils.getCampaignExpiration())}`
            : '';
        const campaignParams = `;searchType=POST_BOOKING${campaignInfoParam}`;
        const authTokenParam = encodeURIComponent(URLUtils.getQueryParam('auth_token') || '');

        return authTokenParam ? `${campaignParams};auth_token=${authTokenParam}` : campaignParams;
    },
};
